// extracted by mini-css-extract-plugin
module.exports = {"hidden":"reportTab_hidden__P8Cib","textEmphasis":"reportTab_textEmphasis__nPJww","matchingSuggest":"reportTab_matchingSuggest__lciYO","basicTitle":"reportTab_basicTitle__iTSCL"};